import FieldSection from "./FieldSection";
import styles from "./SectionRegister.module.css"

function SectionRegister({ thisEntity, descExtra }) {
    return (
        <section className={styles.section}>
            <div className={styles.containerRegistro} style={{gridTemplateRows: `repeat(${thisEntity.length/2}, 1fr);`}}>
                {thisEntity.map(entity => <FieldSection label={entity.label} dado={entity.value} key={entity.label} />)}
            </div>
            <div className={styles.containerExtra}>
                {Array.isArray(descExtra) && descExtra != null ? (descExtra.map(item => item != null ? <FieldSection label={item.label} dado={item.value} key={item.label}/> : "")) : ""}
            </div>
        </section>
    )
}

export default SectionRegister;